import { render, staticRenderFns } from "./ConsumoItensContrato.vue?vue&type=template&id=7203bfde"
import script from "./ConsumoItensContrato.vue?vue&type=script&lang=js"
export * from "./ConsumoItensContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports